import { find } from "lodash"

const GET_USER_LICENSES_REQUEST = "GET_USER_LICENSES_REQUEST"
const GET_USER_LICENSES_SUCCESS = "GET_USER_LICENSES_SUCCESS"
const GET_USER_LICENSES_FAILURE = "GET_USER_LICENSES_FAILURE"
const CLEAR_LICENSES = "CLEAR_LICENSES"

function isLicenseExpired(role, assessmentSetId, userLicenses) {
  if (role === "Student") {
    let val = find(userLicenses, function (val) {
      return val.licenseSet === assessmentSetId
    })
    if (val && Number(val.endDate) < Date.now()) {
      return true
    }
  }
  return false
}

export function getUserLicenseRequest() {
  return {
    type: GET_USER_LICENSES_REQUEST
  }
}

export function getUserLicenseSuccess(userData) {
  return {
    type: GET_USER_LICENSES_SUCCESS,
    userData
  }
}

export function getUserLicenseFailure(error) {
  return {
    type: GET_USER_LICENSES_FAILURE,
    error
  }
}

export function clearLicenses() {
  return {
    type: CLEAR_LICENSES
  }
}

export function setLicensedUsers(usersObj) {
  return {
    type: "SET_LICENSED_USERS",
    usersObj
  }
}

const initialState = {
  fetchingLicenses: false,
  licenseFetched: undefined,
  licensesError: {},
  userlicenses: null,
  licensedUsers: {}
}

export function licenses(state = initialState, action) {
  switch (action.type) {
    case GET_USER_LICENSES_REQUEST:
      return {
        ...state,
        fetchingLicenses: true
      }
    case GET_USER_LICENSES_FAILURE:
      return {
        ...state,
        fetchingLicenses: false,
        licensesError: action.error
      }
    case GET_USER_LICENSES_SUCCESS:
      let licenses = action.userData.licenses
        ? action.userData.licenses.map(license => {
            return {
              ...license,
              isExpired: isLicenseExpired(
                action.userData.role,
                license.licenseSet,
                action.userData.licenses
              )
            }
          })
        : []
      return {
        ...state,
        fetchingLicenses: false,
        licenseFetched: true,
        userlicenses: licenses
      }

    case "SET_LICENSED_USERS":
      return {
        ...state,
        licensedUsers: {
          ...state.licensedUsers,
          ...action.usersObj
        }
      }

    case CLEAR_LICENSES:
      return {
        ...state,
        userlicenses: [],
        licensedUsers: {}
      }

    default:
      return state
  }
}
